import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";

import styles from "./requestStripeForToursStyles";
import ApiUser from "../../../API/ApiUser";
import ApiTour from "../../../API/ApiTour";
import RequestStripeForToursView from "./requestStripeForToursView";

class RequestStripeForToursComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTours: [],
      comment: "",
      showError: false,
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
      tours: [],
      isLoading: true,
      redirectToAccount: false,
    };

    this.resetErrorAlert = this.resetErrorAlert.bind(this);
    this.resetSuccessAlert = this.resetSuccessAlert.bind(this);
  }

  componentDidMount() {
    document.title = "Demande de Stripe pour les parcours | Landing Zone";
    this.getUserTours();
  }

  resetErrorAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showError: false,
      errorMessage: "",
    }));
  }

  resetSuccessAlert() {
    this.setState((prevState) => ({
      ...prevState,
      showSuccess: false,
      successMessage: "",
    }));
  }

  async getUserTours() {
    const response = await ApiTour.getTours();
    if (response.status === 200) {
      const toursWithoutMonetization = response.data.filter(
        (tour) => !tour.userCanMonetizedTour
      );
      this.setState({
        tours: toursWithoutMonetization,
        isLoading: false,
      });
    }
  }

  handleTourSelection = (event) => {
    this.setState({
      selectedTours: event.target.value,
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { t } = this.props;

    if (!this.state.selectedTours.length) {
      this.setState({
        showError: true,
        errorMessage: t("request_stripe_for_tours.error.select_tours"),
        showSuccess: false,
      });
      return;
    }

    try {
      const response = await ApiUser.requestStripeForTours(
        this.state.selectedTours,
        this.state.comment
      );

      if (response.status === 200) {
        this.setState({
          showSuccess: true,
          successMessage: t("request_stripe_for_tours.success.request_sent"),
          showError: false,
          redirectToAccount: true,
        });
      } else {
        this.setState({
          showError: true,
          errorMessage: t("request_stripe_for_tours.error.unknown"),
          showSuccess: false,
        });
      }
    } catch (error) {
      this.setState({
        showError: true,
        errorMessage: t("request_stripe_for_tours.error.unknown"),
        showSuccess: false,
      });
    }
  };

  render() {
    const { classes } = this.props;

    if (this.state.redirectToAccount) {
      return <Redirect to="/user/account?requested_stripe_for_tours=true" />;
    }

    return (
      <RequestStripeForToursView
        {...this.props}
        state={this.state}
        handleTourSelection={this.handleTourSelection}
        handleInputChange={this.handleInputChange}
        handleSubmit={this.handleSubmit}
        resetErrorAlert={this.resetErrorAlert}
        resetSuccessAlert={this.resetSuccessAlert}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withTranslation()(RequestStripeForToursComponent)
);
